import BaseSerializer from '@adc/app-infrastructure/serializers/base-serializer';

export default BaseSerializer;
